import React from 'react';
import { AlertTriangle } from 'lucide-react';
export function ProblemSection() {
  const pains = ['Abrís la heladera y no se te ocurre nada con lo que hay', 'Terminás comiendo mal porque pensar qué hacer requiere energía que no tenés', 'El delivery se acumula en el historial y en la cuenta del banco'];
  return <section className="py-20 px-4 bg-white" data-id="element-157">
      <div className="max-w-4xl mx-auto" data-id="element-158">
        <div className="text-center mb-12" data-id="element-159">
          <div className="inline-flex bg-gray-100 text-brand-mediumGray px-4 py-1.5 rounded-full font-bold text-xs tracking-widest uppercase mb-6" data-id="element-160">
            El problema real
          </div>
          <h2 className="text-3xl md:text-4xl font-serif font-bold text-brand-darkGray leading-tight" data-id="element-161">
            No es que no sabés cocinar. <br className="hidden md:block" data-id="element-162" />
            <span className="italic text-brand-purple" data-id="element-163">
              Es que nadie te enseñó a usar bien tu air fryer.
            </span>
          </h2>
        </div>

        <div className="bg-brand-purple text-white rounded-2xl p-8 md:p-12 shadow-xl text-lg md:text-xl font-medium leading-relaxed mb-8" data-id="element-164">
          <p data-id="element-165">
            Son las 7 de la tarde. Abrís la heladera, la mirás, la cerrás. La
            volvés a abrir. Nada cambia. Al final pedís delivery otra vez, o
            comés cualquier cosa parada frente a la mesada. Y la air fryer ahí,
            tapada con algo encima.
          </p>
        </div>

        <p className="text-xl text-brand-darkGray font-medium text-center mb-12" data-id="element-166">
          Si esto te pasa seguido, no es falta de ganas.{' '}
          <span className="font-bold" data-id="element-167">Es falta de un sistema.</span>
        </p>

        <div className="space-y-4 mb-12" data-id="element-168">
          {pains.map((pain, index) => <div key={index} className="flex items-center gap-4 bg-white p-5 rounded-xl shadow-sm border border-gray-100 border-l-4 border-l-brand-purple" data-id="element-169">
              <div className="flex-shrink-0" data-id="element-170">
                <AlertTriangle className="w-6 h-6 text-brand-purple" data-id="element-171" />
              </div>
              <p className="text-brand-darkGray font-medium text-lg" data-id="element-172">{pain}</p>
            </div>)}
        </div>

        <div className="bg-brand-yellowLight p-6 md:p-8 rounded-xl" data-id="element-173">
          <p className="text-brand-darkGray text-lg font-medium leading-relaxed" data-id="element-174">
            El problema no es la heladera vacía. Es que cada vez que tenés que
            pensar qué cocinar, tu cerebro ya está agotado del día y elige lo
            más fácil — que casi nunca es lo que querés.
          </p>
        </div>
      </div>
    </section>;
}